import React from 'react';
import SkillStyles from './Skill.module.css';


export default function Skill({imagePath,name,refsArray}){
    return <div ref={(skillBoxDOM)=>refsArray.current.push(skillBoxDOM)} className={SkillStyles.SkillBox}>
                <div className={SkillStyles.SkillBoxImageContainer}>
                    <img className={SkillStyles.SkillBoxImage} src={imagePath} alt={name}/>
                </div>
                <h3 className={SkillStyles.SkillBoxTitle}>{name}</h3>
            </div>
}